(function () {
  "use strict";

  window.Shopify = window.Shopify || {};
  window.Shopify.routes = window.Shopify.routes || { root: "/" };

  /* ---------------------------------------------------------------------
     Header: scroll state, mobile menu, smooth-scroll nav links
     --------------------------------------------------------------------- */
  var header = document.querySelector("[data-site-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  var menuToggle = document.querySelector("[data-menu-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      mobileMenu.classList.toggle("is-open");
    });
  }

  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-scroll-link]");
    if (!link) return;
    var href = link.getAttribute("href") || "";
    if (href.charAt(0) !== "#") return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    if (mobileMenu) mobileMenu.classList.remove("is-open");
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* ---------------------------------------------------------------------
     Scroll reveal
     --------------------------------------------------------------------- */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if (revealEls.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* ---------------------------------------------------------------------
     FAQ accordion
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-faq]").forEach(function (faq) {
    var items = faq.querySelectorAll("[data-faq-item]");
    items.forEach(function (item, index) {
      var btn = item.querySelector("[data-faq-toggle]");
      if (!btn) return;
      if (index === 0) item.classList.add("is-open");
      btn.addEventListener("click", function () {
        var wasOpen = item.classList.contains("is-open");
        items.forEach(function (i) {
          i.classList.remove("is-open");
        });
        if (!wasOpen) item.classList.add("is-open");
      });
    });
  });

  /* ---------------------------------------------------------------------
     Countdown timers
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-countdown]").forEach(function (el) {
    // Real, fixed end date set by the merchant (section setting), never resets.
    var target = new Date(el.dataset.end);
    if (isNaN(target.getTime())) return;
    var daysEl = el.querySelector("[data-days]");
    var hEl = el.querySelector("[data-h]");
    var mEl = el.querySelector("[data-m]");
    function tick() {
      var diff = Math.max(0, target - new Date());
      if (diff <= 0) {
        var section = el.closest("section");
        if (section) section.style.display = "none";
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      if (daysEl) daysEl.textContent = String(days).padStart(2, "0");
      if (hEl) hEl.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, "0");
      if (mEl) mEl.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------------------------------------------------------------------
     Product forms: variant swatches + pack quantity
     --------------------------------------------------------------------- */
  function formatMoney(amount) {
    return amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€";
  }

  function assetUrl(filename) {
    return (window.themeAssetsUrl || "/") + filename;
  }

  document.querySelectorAll("[data-product-form]").forEach(function (root) {
    var dataEl = root.querySelector("[data-product-json]");
    if (!dataEl) return;
    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!variants.length) return;

    var idInput = root.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('input[name="quantity"]');
    var visual = root.querySelector("[data-visual]");
    var swatchContainer = root.querySelector("[data-swatches]");
    var swatchStyle = swatchContainer ? swatchContainer.dataset.swatchStyle : null;
    var personaLabel = root.querySelector("[data-persona-label]");
    var addBtn = root.querySelector("[data-add-to-cart]");
    var visualImg = null;

    if (visual) {
      visualImg = document.createElement("img");
      visualImg.alt = root.dataset.productTitle || "";
      visual.appendChild(visualImg);
    }

    function variantImageSrc(variant) {
      return variant.image || assetUrl(variant.meta.asset);
    }

    function buildSwatches() {
      if (!swatchContainer) return;
      swatchContainer.innerHTML = "";
      variants.forEach(function (variant) {
        var el;
        if (swatchStyle === "cards") {
          el = document.createElement("button");
          el.type = "button";
          el.className = "color-card";
          el.innerHTML =
            '<div class="color-card__head">' +
            '<span class="color-card__dot" style="background:' + variant.meta.hex + '"></span>' +
            '<div><p class="color-card__persona">' + variant.meta.persona + "</p>" +
            '<p class="color-card__name">' + variant.option1 + "</p></div></div>" +
            '<p class="color-card__tagline">' + variant.meta.tagline + "</p>" +
            '<div class="color-card__tags">' +
            variant.meta.bestFor.map(function (t) { return "<span>" + t + "</span>"; }).join("") +
            "</div>";
        } else {
          el = document.createElement("button");
          el.type = "button";
          el.className = "swatch";
          el.setAttribute("aria-label", variant.option1);
          el.style.background = variant.meta.hex;
          el.style.setProperty("--ring", variant.meta.ring);
        }
        el.dataset.swatch = "true";
        el.dataset.color = variant.option1;
        el.disabled = !variant.available;
        el.addEventListener("click", function () {
          selectVariant(variant);
        });
        swatchContainer.appendChild(el);
      });
    }

    function selectVariant(variant) {
      if (!variant || !idInput) return;
      idInput.value = variant.id;

      if (visualImg) {
        visualImg.classList.remove("is-active");
        setTimeout(function () {
          visualImg.src = variantImageSrc(variant);
          visualImg.classList.add("is-active");
        }, 120);
      }

      if (swatchContainer) {
        swatchContainer.querySelectorAll("[data-swatch]").forEach(function (sw) {
          sw.classList.toggle("is-selected", sw.dataset.color === variant.option1);
        });
      }
      if (personaLabel) {
        personaLabel.textContent = variant.meta.persona
          ? variant.meta.persona + " — " + variant.option1
          : variant.option1;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.dataset.labelAvailable
          : addBtn.dataset.labelSoldOut;
      }
    }

    var packButtons = root.querySelectorAll("[data-pack]");
    var priceEl = root.querySelector("[data-computed-price]");
    var unitPrice = parseFloat(root.dataset.unitPrice || "0");
    packButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        packButtons.forEach(function (b) {
          b.classList.remove("is-selected");
        });
        btn.classList.add("is-selected");
        var qty = parseInt(btn.dataset.qty, 10) || 1;
        if (qtyInput) qtyInput.value = qty;
        if (priceEl && unitPrice) priceEl.textContent = formatMoney(unitPrice * qty);
      });
    });

    buildSwatches();
    selectVariant(variants[0]);
    if (visualImg) visualImg.classList.add("is-active");
  });

  /* ---------------------------------------------------------------------
     AJAX add to cart
     --------------------------------------------------------------------- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-add-to-cart-form]");
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector("[data-add-to-cart]");
    if (btn) {
      btn.disabled = true;
      btn.classList.add("is-loading");
    }
    var formData = new FormData(form);
    formData.append("sections", "cart-drawer,header");

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) {
          console.error(data.description || "Impossible d'ajouter cet article au panier.");
          return;
        }
        renderCartSections(data.sections);
        openCartDrawer();
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove("is-loading");
        }
      });
  });

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var target = document.getElementById("shopify-section-" + id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(sections[id], "text/html");
      var replacement = doc.getElementById("shopify-section-" + id);
      target.innerHTML = replacement ? replacement.innerHTML : sections[id];
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.removeAttribute("hidden");
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
    });
    document.body.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () {
      drawer.setAttribute("hidden", "");
    }, 350);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.closest("[data-cart-close]")) {
      e.preventDefault();
      closeCartDrawer();
    }
  });

  /* ---------------------------------------------------------------------
     Cart line quantity / remove (event delegation — drawer re-renders)
     --------------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-change]");
    if (!btn) return;
    e.preventDefault();
    var line = btn.dataset.line;
    var quantity = parseInt(btn.dataset.quantity, 10);
    btn.closest("[data-cart-drawer]") && btn.closest("[data-cart-drawer]").classList.add("is-updating");

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity, sections: "cart-drawer,header" }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        renderCartSections(data.sections);
      })
      .catch(function (err) {
        console.error(err);
      });
  });

  // Cookie consent is handled by Shopify's native Customer Privacy banner
  // (Preferences > Customer privacy), which also gates Shopify's own
  // tracking scripts. No custom consent UI needed here.
})();
